import { Space } from "@gocardless/flux-react";
import {
  BankAuthorisationResource,
  CreditorBankAccountResource,
} from "@gocardless/api/dashboard/types";

import BankDetailsCard from "../features/bank-details-card/BankDetailsCard";
import InternationalPaymentsOptions from "../features/international-payments/InternationalPaymentsOptions";

import { Currency } from "src/common/currencies";

interface BankDetailsCardSectionProps {
  primaryAccount: CreditorBankAccountResource;
  bankAuthorisation?: BankAuthorisationResource;
  internationalPaymentsEnabled: boolean;
  primaryCurrency: string;
  setShowAddAdditionalBanks: (show: boolean) => void;
  setShowPrimaryBankForm: (show: boolean) => void;
}

export const BankDetailsCardSection: React.FC<BankDetailsCardSectionProps> = ({
  primaryAccount,
  bankAuthorisation,
  internationalPaymentsEnabled,
  setShowAddAdditionalBanks,
  primaryCurrency,
  setShowPrimaryBankForm,
}) => (
  <>
    <BankDetailsCard
      accountName={primaryAccount.account_holder_name}
      accountNumberEnding={primaryAccount.account_number_ending}
      bankName={primaryAccount.bank_name}
      currency={primaryCurrency as Currency}
      handleUpdate={() => setShowPrimaryBankForm(true)}
      bankAuthorisation={bankAuthorisation}
    />
    <Space v={4} />
    <InternationalPaymentsOptions
      internationalPaymentsEnabled={internationalPaymentsEnabled}
      handleAddBanks={() => {
        setShowAddAdditionalBanks(true);
      }}
    />
    <Space v={2} />
  </>
);
